import React from 'react'
import I18n from 'jsx!Component/I18n'

let Thead = React.createClass({

  getDefaultProps: function () {
    return {
      onSort: null,
      sortBy: null,
      sortDir: null,
      filterField: null,
      filterChange: null,
      labels: []
    };
  },

  propTypes: {
    onSort: React.PropTypes.func,
    sortBy: React.PropTypes.string,
    sortDir: React.PropTypes.string,
    labels: React.PropTypes.array
  },

  onSort: function (field, e) {
    e.preventDefault();
    this.props.onSort && this.props.onSort(field);
  },

  render: function () {
    let cols = this.props.labels.map(function (item, key) {
      if (item.sortable) {
        let sort = '';
        if (item.name === this.props.sortBy) {
          sort = this.props.sortDir === 'DESC' ? '▼' : '▲';
        }
        return (
          <th key={key}>
            <a href="#" onClick={this.onSort.bind(this, item.name)}>
              <I18n message={item.label}/>
            </a>
            {sort}
          </th>
        );

      } else if (this.props.filterField && ((this.props.filterField instanceof Array && this.props.filterField.indexOf(item.name) >= 0) || item.name === this.props.filterField)) {
        return (
          <th key={key}>
            <input className="table-filter" placeholder={I18n.message(item.label)}
                   onChange={this.props.filterChange.bind(null, item.name)}/>
          </th>
        );
      } else {
        return (
          <th key={key}><I18n message={item.label}/></th>
        );
      }
    }.bind(this));

    return (
      <thead>
      <tr>
        {cols}
      </tr>
      </thead>
    );
  }
});
export default Thead;



// WEBPACK FOOTER //
// ./src/js/Component/Table/Thead.jsx